import * as XLSX from 'xlsx'
import type { GridImportColumn } from '../types'

const SKIP_TYPES = new Set(['checkbox', 'seq', 'image', 'file', 'files'])

export function getImportColumns(columns: GridImportColumn[]) {
  return columns.filter(
    (col) =>
      col.field && col.importable !== false && !SKIP_TYPES.has(col.type ?? '')
  )
}

export function buildImportTemplateHeader(column: GridImportColumn) {
  const title = String(column.title || column.field)
    .replace(/^\*+\s*/u, '')
    .replace(/\*+$/u, '')
    .trim()
  return column.required ? `*${title}` : title
}

export function downloadImportTemplate(
  columns: GridImportColumn[],
  filename = '导入模板.xlsx',
  sheetName = '导入模板'
) {
  const importColumns = getImportColumns(columns)
  if (!importColumns.length) {
    return false
  }

  const headerRow = importColumns.map((col) => buildImportTemplateHeader(col))
  const sheet = XLSX.utils.aoa_to_sheet([headerRow])
  sheet['!cols'] = headerRow.map((header) => ({
    wch: Math.min(Math.max(String(header).length + 4, 12), 32),
  }))

  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, sheet, sheetName)
  XLSX.writeFile(workbook, filename)
  return true
}
